import moment from 'moment';
import { Currency } from '@repo-level/core-front';

import { Lootbox, LootboxStage } from 'api/common';
import { getCurrencyCentsAndCode } from 'helpers/wallet';
import {
  groupMemberDIAMOND,
  groupMemberGOLD,
  groupMemberPLATINUM,
} from 'helpers/user';

export const SPINS_PER_DAY = 5;

export const SPINS_PER_DAY_GOLD = 7;
export const SPINS_PER_DAY_PLATINUM = 10;
export const SPINS_PER_DAY_DIAMOND = 15;

export const isToday = (date: string): boolean => {
  const createdAtDate = moment.utc(date);
  const currentUtcDate = moment.utc();

  return createdAtDate.isSame(currentUtcDate, 'day');
};

export const getTimeUntilNextDay = (): number => {
  const currentUtcTime = moment.utc();
  const nextDayUtc = moment.utc().add(1, 'days').startOf('day');

  return nextDayUtc.diff(currentUtcTime) / 1000;
};

export const convertMaxWin = (
  values: { currency: string; amountCents: number }[],
  currencies: Currency[]
): string => {
  const amountsMap: { [key: string]: string[] } = {};

  const maxWinCurrencies = values.map((value) => {
    return getCurrencyCentsAndCode(
      value.amountCents,
      value.currency,
      currencies
    );
  });

  maxWinCurrencies.forEach((item) => {
    if (amountsMap[item.amount]) {
      amountsMap[item.amount].push(item.currency);
    } else {
      amountsMap[item.amount] = [item.currency];
    }
  });

  return Object.entries(amountsMap)
    .map(([amountCents, currencies]) => {
      return `${amountCents} ${currencies.join('/')}`;
    })
    .join(', ');
};

export const getSpinsData = (lootboxes: Lootbox[], user?: any) => {
  if (!user) return { remains: SPINS_PER_DAY, total: SPINS_PER_DAY };

  const spinsPerDay = (() => {
    if (groupMemberDIAMOND(user)) return SPINS_PER_DAY_DIAMOND;
    if (groupMemberPLATINUM(user)) return SPINS_PER_DAY_PLATINUM;
    if (groupMemberGOLD(user)) return SPINS_PER_DAY_GOLD;
    return SPINS_PER_DAY;
  })();

  const currentLootboxes = [...lootboxes].filter((lootbox) =>
    isToday(lootbox.createdAt)
  );
  const activatedLootboxes = [...currentLootboxes].filter(
    ({ stage, title }) =>
      stage === LootboxStage.Activated &&
      !EXTRA_SPIN_LOOTBOX_TITLES.includes(title)
  );
  return {
    remains: spinsPerDay - activatedLootboxes.length,
    total: spinsPerDay,
  };
};

export const formatLootboxItemTitle = (str: string): string => {
  const regex = new RegExp(`\\b\\s*Wheel\\b`, 'gi');
  return str.replace(regex, '').trim();
};

export const EXTRA_SPIN_LOOTBOX_TITLES = [
  'Extra Lucky Spin',
  'VIP Extra Lucky Spin',
];
